import React from "react";
import DoughnutChart from "../Charts/DoughnutChart/DoughnutChart";

const AssessmentOverview = ({ data }) => {
  return (
    <div className="flex flex-wrap gap-y-9 gap-x-5 font-rubik">
      {data.rom_exercise_stats && (
        <div className="border rounded-md px-5 py-5 border-[#b5b5b5] bg-[#fff]">
          <div className="text-xl leading-5 font-semibold text-[#3F3D56] mb-3">
            {data.rom_exercise_stats.exercise_type}
          </div>
          <div
            className="flex items-center gap-3 rounded-md px-3 py-4"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.09)",
            }}
          >
            <>
              {data.rom_exercise_stats.legends.map((item, index) => {
                return (
                  <div className="flex items-center gap-2 text-xs leading-[22px] font-normal text-[#18191A] opacity-70" key={index}>
                    <div
                      className="h-[18px] w-[18px] rounded-[50%]"
                      style={{
                        backgroundColor: item.color_code,
                      }}
                    ></div>{" "}
                    {item.legend}
                  </div>
                );
              })}
            </>
          </div>
          <div className="flex gap-2 justify-center items-center rounded-[5px] bg-[#3F3D56] bg-opacity-5 py-3 mt-3 mb-[10px]">
            <div className="text-base font-medium leading-[22px]">
              {data.rom_exercise_stats.interpretation}
            </div>
            <div className="text-2xl leading-9  font-semibold">
              {data.rom_exercise_stats.interpretation_score}{" "}
            </div>
          </div>
          <DoughnutChart chartData={data.rom_exercise_stats} />
        </div>
      )}
      {data.reps_exercise_stats && (
        <div className="border rounded-md px-5 py-5 border-[#b5b5b5] bg-[#fff]">
          <div className="text-xl leading-5 font-semibold text-[#3F3D56] mb-3">
            {data.reps_exercise_stats.exercise_type}
          </div>
          <div
            className="flex items-center gap-3 rounded-md px-3 py-4"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.09)",
            }}
          >
            <>
              {data.reps_exercise_stats.legends.map((item, index) => {
                return (
                  <div className="flex items-center gap-2 text-xs leading-[22px] font-normal text-[#18191A] opacity-70" key={index}>
                    <div
                      className="h-[18px] w-[18px] rounded-[50%]"
                      style={{
                        backgroundColor: item.color_code,
                      }}
                    ></div>{" "}
                    {item.legend}
                  </div>
                );
              })}
            </>
          </div>
          <div className="flex gap-2 justify-center items-center rounded-[5px] bg-[#3F3D56] bg-opacity-5 py-3 mt-3 mb-[10px]">
            <div className="text-base font-medium leading-[22px]">
              {data.reps_exercise_stats.interpretation}
            </div>
            <div className="text-2xl leading-9  font-semibold">
              {data.reps_exercise_stats.interpretation_score}{" "}
            </div>
          </div>
          <DoughnutChart chartData={data.reps_exercise_stats} />
        </div>
      )}
      {data.balance_exercise_stats && (
        <div className="border rounded-md px-5 py-5 border-[#b5b5b5] bg-[#fff]">
          <div className="text-xl leading-5 font-semibold text-[#3F3D56] mb-3">
            {data.balance_exercise_stats.exercise_type}
          </div>
          <div
            className="flex items-center gap-3 rounded-md px-3 py-4"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.09)",
            }}
          >
            <>
              {data.balance_exercise_stats.legends.map((item, index) => {
                return (
                  <div className="flex items-center gap-2 text-xs leading-[22px] font-normal text-[#18191A] opacity-70" key={index}>
                    <div
                      className="h-[18px] w-[18px] rounded-[50%]"
                      style={{
                        backgroundColor: item.color_code,
                      }}
                    ></div>{" "}
                    {item.legend}
                  </div>
                );
              })}
            </>
          </div>
          <div className="flex gap-2 justify-center items-center rounded-[5px] bg-[#3F3D56] bg-opacity-5 py-3 mt-3 mb-[10px]">
            <div className="text-base font-medium leading-[22px]">
              {data.balance_exercise_stats.interpretation}
            </div>
            <div className="text-2xl leading-9  font-semibold">
              {data.balance_exercise_stats.interpretation_score}{" "}
            </div>
          </div>
          <DoughnutChart chartData={data.balance_exercise_stats} />
        </div>
      )}
    </div>
  );
};

export default AssessmentOverview;
